import { createSlice } from "@reduxjs/toolkit";

const initialDatasetState = {
  transcripts: [],
  sortOrder: "Upload date descending",
};

const filteredArchiveSlice = createSlice({
  name: "filteredArchive",
  initialState: initialDatasetState,
  reducers: {
    setFilteredArchive(state, action) {
      state.transcripts = action.payload;
    },
    setSortOrder(state, action){
      state.sortOrder = action.payload
    },

  },
});

export const { setFilteredArchive, setSortOrder } =
  filteredArchiveSlice.actions;

export default filteredArchiveSlice.reducer;